import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core'
import { FieldType } from '@ngx-formly/core'
import { Observable, Subject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'

@Component({
  selector: 'basin-formly-dropdown',
  templateUrl: './formly-dropdown.component.html',
  styleUrls: ['./formly-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyDropdownComponent
  extends FieldType
  implements OnInit, OnDestroy
{
  private ngUnsubscribe = new Subject<void>()

  ngOnInit(): void {
    if (this.props) {
      if (this.props.initialize && Object.keys(this.model).length === 0) {
        this.setModel()
      } else {
        this.initializeFromArray(this.props.options)
      }
    }
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next()
    this.ngUnsubscribe.complete()
  }

  initializeFromArray(options: any[] | Observable<any[]>) {
    if (
      Array.isArray(options) &&
      options.length > 0 &&
      this.props.autoDisplayFirst
    ) {
      this.formControl.setValue(options[0])
    }
  }

  setModel(): void {
    ;(this.props.options as Observable<any>)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((result) => {
        if (result && result.length > 0) {
          this.formControl.setValue(result[0][this.props.valueProp])
          this.options.updateInitialValue()
        }
      })
  }

  checkIfObservable(options: Observable<any[]> | any[]) {
    return options instanceof Observable
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Home' || event.key === 'End') {
      event.stopPropagation()
    }
  }
}
